import { render } from "./slide2.vue?vue&type=template&id=118e71af&scoped=true"
import script from "./slide2.vue?vue&type=script&lang=js"
export * from "./slide2.vue?vue&type=script&lang=js"

import "./slide2.vue?vue&type=style&index=0&id=118e71af&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118e71af"]])

export default __exports__